module.exports = __webpack_public_path__ + "static/media/login_bg.b6679271.png";